var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 6.1123C15.5 6.5498 15.1562 6.8623 14.75 6.8623H11.25H10.25C9.8125 6.8623 9.5 6.5498 9.5 6.1123C9.5 5.70605 9.8125 5.3623 10.25 5.3623H11.25H12.9375L11.3125 3.7373C10.4062 2.8623 9.21875 2.3623 8 2.3623C5.71875 2.3623 3.75 3.76855 2.9375 5.7373C2.75 6.1123 2.3125 6.26855 1.9375 6.1123C1.5625 5.95605 1.375 5.51855 1.53125 5.14355C2.59375 2.64355 5.09375 0.862305 8 0.862305C9.625 0.862305 11.1875 1.51855 12.3438 2.6748L14 4.33105V2.6123V1.6123C14 1.20605 14.3125 0.862305 14.75 0.862305C15.1562 0.862305 15.5 1.20605 15.5 1.6123V6.1123ZM1.25 8.8623H4.75C5.15625 8.8623 5.5 9.20605 5.5 9.6123C5.5 10.0498 5.15625 10.3623 4.75 10.3623H3.03125L4.6875 12.0186C5.5625 12.8936 6.75 13.3623 8 13.3623C10.25 13.3623 12.2188 12.0186 13.0312 10.0498C13.2188 9.64355 13.6562 9.4873 14.0312 9.64355C14.4062 9.7998 14.5938 10.2373 14.4375 10.6436C13.3438 13.1123 10.875 14.8623 8 14.8623C6.34375 14.8623 4.78125 14.2373 3.625 13.0811L2 11.4248V13.1123C2 13.5498 1.65625 13.8623 1.25 13.8623C0.8125 13.8623 0.5 13.5498 0.5 13.1123V9.6123C0.5 9.20605 0.8125 8.8623 1.25 8.8623Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh_icon.2f928731654ff7285948a5fc350ddc66.svg";
export { ForwardRef as ReactComponent };